import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  constructor(private httpClient: HttpClient) {}

  createUserTokenGuid(): Observable<any> {
    return this.httpClient.get('/ExternalUserToken/CreateAccessToken');
  }

  createUserOneTimeToken(): Observable<any> {
    return this.httpClient.get('/ExternalUserToken/CreateOneTimeToken');
  }

  resetUserAccessToken(): Observable<any> {
    return this.httpClient.put('/ExternalUserToken/ResetAccessToken', undefined);
  }
}
